import { render, staticRenderFns } from "./edit_datos.vue?vue&type=template&id=09597e57"
import script from "./edit_datos.vue?vue&type=script&lang=js"
export * from "./edit_datos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports